import { useState } from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'
import {
  Button,
  ButtonGroup,
  Grid,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
} from '@mui/material'
import { DateRangePicker } from '@mui/lab'

import {
  START_DATE_QUARTER_DATA,
  TODAY_DATE,
} from '../../../../common/constants'
import { getSubMonthsDate } from '../../../../libs/date'
import useTranslations from '../../../../i18n/useTranslations'
import { ReactComponent as CaretLeft } from '../../../../assets/icons/caret-left.svg'
import { ReactComponent as CaretRight } from '../../../../assets/icons/caret-right.svg'
import { ReactComponent as CalendarBlank } from '../../../../assets/icons/calendar-blank.svg'

const DateRange = ({ values, setValues }) => {
  const t = useTranslations()
  const [selectedBtn, setSelectedBtn] = useState('custom')

  const rangeConfig = {
    month: {
      dateFrom: getSubMonthsDate(1),
      dateTo: TODAY_DATE,
    },
    quarter: {
      dateFrom: START_DATE_QUARTER_DATA,
      dateTo: TODAY_DATE,
    },
  }

  const handleClickNotCustom = ev => {
    const newId = ev.target.id
    setSelectedBtn(newId)
    setValues(values => ({
      ...values,
      ...rangeConfig[newId],
    }))
  }

  const onAcceptDateRange = selectedRange => {
    const [from, to] = selectedRange

    setValues(values => ({
      ...values,
      dateFrom: format(new Date(from), 'yyyy-MM-dd'),
      dateTo: format(new Date(to), 'yyyy-MM-dd'),
    }))
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        <Typography variant="h4bold" gutterBottom sx={{ display: 'block' }}>
          {t('noun:search-by-date')}
        </Typography>
        <ButtonGroup sx={{ mb: 3, width: '100%', '& > *': { flex: '1' } }}>
          <Button
            id="custom"
            variant={selectedBtn === 'custom' ? 'contained' : 'outlined'}
            onClick={() => setSelectedBtn('custom')}
          >
            {t('noun:any-date')}
          </Button>
          <Button
            id="month"
            variant={selectedBtn === 'month' ? 'contained' : 'outlined'}
            onClick={handleClickNotCustom}
          >
            {t('noun:last-month')}
          </Button>
          <Button
            id="quarter"
            variant={selectedBtn === 'quarter' ? 'contained' : 'outlined'}
            onClick={handleClickNotCustom}
          >
            {t('noun:last-quarter')}
          </Button>
        </ButtonGroup>
        {selectedBtn === 'custom' ? (
          <DateRangePicker
            startText="Desde"
            endText="Hasta"
            value={[values.dateFrom, values.dateTo]}
            onChange={() => {}}
            onAccept={onAcceptDateRange}
            components={{
              LeftArrowIcon: CaretLeft,
              RightArrowIcon: CaretRight,
            }}
            renderInput={(startProps, endProps) => (
              <>
                <TextField
                  {...startProps}
                  className="full-width"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disabled
                          aria-label="open date range picker"
                        >
                          <CalendarBlank />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  {...endProps}
                  className="full-width"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disabled
                          aria-label="open date range picker"
                        >
                          <CalendarBlank />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </>
            )}
          />
        ) : null}
      </Grid>
    </Grid>
  )
}
DateRange.propTypes = {
  values: PropTypes.shape({
    dateFrom: PropTypes.string.isRequired,
    dateTo: PropTypes.string.isRequired,
  }),
  setValues: PropTypes.func.isRequired,
}

export default DateRange
